import React, { useState } from 'react';
import './Website.css';

const initialForm = {
  firstName: '',
  lastName: '',
  email: '',
  message: '',
};

export default function ContactUs() {
  const [formData, setFormData] = useState(initialForm);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  return (
    <main className="site-page utility-page">
      <section className="section-inner contact-grid">
        <div className="utility-copy">
          <p className="eyebrow">Support</p>
          <h1>Need help with Unsubscriber?</h1>
          <p>
            Send the account email you use with the extension and a short description of what happened. Support can help with checkout, scans, account state, and cleanup behavior.
          </p>
          <div className="contact-facts">
            <div><strong>US-based</strong><span>customer support</span></div>
            <div><strong>Stripe</strong><span>billing support</span></div>
            <div><strong>Gmail</strong><span>extension guidance</span></div>
          </div>
        </div>

        <form className="contact-card" action="https://formspree.io/f/mvgkpebv" method="POST">
          <input type="hidden" name="_subject" value="Mass Unsubscriber support request" />
          <div className="form-row">
            <label>
              First name
              <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
            </label>
            <label>
              Last name
              <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
            </label>
          </div>
          <label>
            Email
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </label>
          <label>
            Message
            <textarea name="message" rows="6" value={formData.message} onChange={handleChange} required />
          </label>
          <button className="button button-primary" type="submit">Send message</button>
        </form>
      </section>
    </main>
  );
}
